import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ResumeStatusService {
  private _resumeStatus = signal(false);

  resumeStatusUpdated = this._resumeStatus.asReadonly();

  setResumeStatusUpdated(value: boolean) {
    this._resumeStatus.set(value);
  }
}